import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Manufacturing.frontend.types'

@Injectable({ providedIn: 'root' })
export class Manufacturing_cancel_manufacturing_order_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { order_id?: number }): Promise<{ reasons?: string[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/functions/cancel_manufacturing_order_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

